<template>
    <div>
      <nav-breadcrumb :menu="[{label: '客户账号列表'}]"/>
      <div class="xzpadd10 bg-purple">
        <data-table
          :tableData="customerUserListData"
          :columns="customerUserListColumns"
          :filters="filters"
          :pageSize.sync="pageSize"
          :page.sync="page"
        ></data-table>
      </div>
    </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import DataTable from '../../../components/DataTable'
  import Status2CN from "../../../filters/Status2CN";
  import {removeItem, xmlBuildQuery} from '../../../filters/CommonActions'
  import moment from 'moment'

  export default {
    data() {
      return {
        page: 1,
        pageSize: 10,
        customerUserListData: {},
        customerUserListColumns: [
          {
            name: '用户名',
            field: 'u__userCode'
          },
          {
            name: '客户名称',
            field: 'c__customerName'
          },
          {
            name: '客户编号',
            field: 'c__customerCode'
          },
          {
            name: '姓名',
            field: 'u__userName'
          },
          {
            name: '手机',
            field: 'u__telephone'
          },
          {
            name: '邮箱',
            field: 'u__email'
          },
          {
            name: '状态',
            field: 'u__disabled',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '创建日期',
            field: 'c__createdDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            name: '操作',
            opts:[
              {
                class: 'el-icon-edit',
                name: '编辑',
                clickHandler: (index, row)=>{
                  this.editItem(index, row)
                }
              }
            ]
          }
        ],
        filters: {
          form: {
            u__userCode: '',
            u__userName: '',
            u__telephone: '',
            c__customerId: '',
            c__customerName: '',
            i__contactTelNo: '',
            u__disabled: ''
          },
          columns: [
            {
              label: '用户名',
              component: 'el-input',
              field: 'u__userCode'
            },
            {
              label: '客户名称',
              component: 'el-input',
              field: 'c__customerName'
            },
            {
              label: '客户编号',
              component: 'el-input',
              field: 'c__customerCode'
            },
            {
              label: '姓名',
              component: 'el-input',
              field: 'u__userName'
            },
            {
              label: '手机',
              component: 'el-input',
              field: 'u__telephone'
            },
            {
              label: '邮箱',
              component: 'el-input',
              field: 'u__email'
            },
            {
              label: '状态',
              component: 'el-select',
              field: 'u__disabled',
              options:[
                {
                  label: '启用',
                  value: 'N'
                },
                {
                  label: '禁用',
                  value: 'Y'
                }
              ]
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerUserList()
          }
        }
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'c.createdDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerUserList()
      }
    },
    mounted() {
      this.getCustomerUserList()
    },
    components: {
      DataTable
    },
    methods: {
      getCustomerUserList: function () {
        xhr.getCustomerUserList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.customerUserListData = res.data
            }catch(e){

            }
          })

      },
      editItem: function (index, row) {
        try{
          this.$router.push({
            'path': 'Edit?u.userId='+row.u__userId
          })
        }catch (e) {

        }
      },
      removeItem: function (index, row) {
        removeItem(
          xhr.deleteFinanceProduct,

          {
            'u.userId': row.u__userId
          },

          ()=>{
            this.getCustomerUserList()
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerUserList.vue